import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { DEFAULT_SCROLL_SPEED_SECONDS } from '../utils/bannerHtml';

const EMPTY_BANNER = Object.freeze({
  html: '',
  enabled: true,
  scrollEnabled: false,
  scrollSpeedSeconds: DEFAULT_SCROLL_SPEED_SECONDS,
  loading: true,
});

export function useSiteBanner() {
  const [banner, setBanner] = useState(EMPTY_BANNER);

  useEffect(() => {
    const ref = doc(db, 'app_settings', 'banner');
    const unsubscribe = onSnapshot(
      ref,
      (snap) => {
        if (!snap.exists()) {
          setBanner({
            html: '',
            enabled: true,
            scrollEnabled: false,
            scrollSpeedSeconds: DEFAULT_SCROLL_SPEED_SECONDS,
            loading: false,
          });
          return;
        }
        const data = snap.data() || {};
        const legacyText = String(data.text || '').trim();
        let html = String(data.html || '').trim();
        if (!html && legacyText) {
          html = `<p>${legacyText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</p>`;
        }
        const scrollSpeedSeconds = Number(data.scrollSpeedSeconds);
        setBanner({
          html,
          enabled: data.enabled !== false,
          scrollEnabled: data.scrollEnabled === true,
          scrollSpeedSeconds: Number.isFinite(scrollSpeedSeconds) && scrollSpeedSeconds > 0
            ? scrollSpeedSeconds
            : DEFAULT_SCROLL_SPEED_SECONDS,
          loading: false,
        });
      },
      () => {
        setBanner((prev) => ({ ...prev, loading: false }));
      }
    );

    return unsubscribe;
  }, []);

  return banner;
}
